import React from "react";
import UseContext from "hooks/useContext";
import { Building, ChevronDown, User } from "assets/icons";
import {
    TOOL_PROVIDER_COMPANY,
    TOOL_PROVIDERS,
    getToolProviderLabel,
    normalizeToolProvider,
} from "pages/missionTemplates/utils/templateTools";

const ToolProviderSelect = ({ value, onChange, ariaLabel }) => {
    const { language } = UseContext();
    const provider = normalizeToolProvider(value);
    const ProviderIcon = provider === TOOL_PROVIDER_COMPANY ? Building : User;

    return (
        <div className="relative shrink-0">
            {/* Native select for built-in keyboard support; <option> cannot render icons, hence the overlays. */}
            <span
                className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
                aria-hidden="true"
            >
                <ProviderIcon wh={20} color="#374151" />
            </span>
            <select
                value={provider}
                onChange={(event) => onChange(event.target.value)}
                aria-label={ariaLabel}
                className="h-10 pl-10 pr-9 ft-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg appearance-none cursor-pointer hover:border-gray-400 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            >
                {TOOL_PROVIDERS.map((toolProvider) => (
                    <option key={toolProvider} value={toolProvider}>
                        {getToolProviderLabel(language, toolProvider)}
                    </option>
                ))}
            </select>
            <span
                className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
                aria-hidden="true"
            >
                <ChevronDown wh={20} color="#374151" />
            </span>
        </div>
    );
};

export default ToolProviderSelect;
